
import { onMounted, computed } from "vue";
import store from "../store";
// Landscaping Components
import LandscapingBar from "../components/Bar.vue";
import LandscapingHeader from "../components/Home/Landscaping/Header.vue";
import LandscapingHero from "../components/Home/Landscaping/Hero.vue";
import LandscapingAboutUs from "../components/Home/Landscaping/AboutUs.vue";
import LandscapingServiceArea from "../components/Home/Landscaping/ServiceArea.vue";
import LandscapingShowcase from "../components/Home/Landscaping/Showcase.vue";
import LandscapingQuestion from "../components/Home/Landscaping/Question.vue";
import LandscapingFooter from "../components/Home/Landscaping/Footer.vue";
import LandscapingChatButton from "../components/Home/Landscaping/ChatButton.vue";

export default {
  name: "Home",
  components: {
    // Landscaping Components
    LandscapingBar,
    LandscapingHeader,
    LandscapingHero,
    LandscapingAboutUs,
    LandscapingServiceArea,
    LandscapingShowcase,
    LandscapingQuestion,
    LandscapingFooter,
    LandscapingChatButton,
  },

  setup() {
    onMounted(() => {
      store.dispatch("fetchGardenBasicData");
      store.dispatch("fetchGardenServiceData");
      store.dispatch("fetchGardenCaseData");
      store.dispatch("fetchGardenQuestionData");
      store.dispatch("fetchGardenMessageData");
    });

    const gardenBasicData = computed(() => store.state.gardenBasicData[0]);
    const gardenServiceData = computed(() => store.state.gardenServiceData);
    const gardenCaseData = computed(() => store.state.gardenCaseData);
    const gardenQuestionData = computed(() => store.state.gardenQuestionData);
    const gardenMessageData = computed(() => store.state.gardenMessageData);

    return {
      gardenBasicData,
      gardenServiceData,
      gardenCaseData,
      gardenQuestionData,
      gardenMessageData,
    };
  },
};
